<template>
<b-form @submit="onSubmit">
    <b-row class="no-gutters mt-2 mr-2 OTsectionHeader" >
        <b-col cols="12" md="6">
            <h1>Ingestion Filters</h1>
            <p>
                Use these filters to prevent the crawler from sending content downstream. The crawler will still fetch and crawl links.
            </p>
        </b-col>
        <b-col class="text-right OTbtnContainer" cols="12" md="6">
            <b-button type="button" variant=" OTSecondary" @click="$router.push({name: 'jobs'})">Cancel</b-button>
            <b-button type="submit" variant=" OTPrimary">Save</b-button>
        </b-col>
    </b-row>
    <b-row class="no-gutters mt-2 mr-2">
        <b-col>
            <URLFilterInput class="OTurlFilter"  v-model="ingestion_filters" :filterEnabled="true"></URLFilterInput>
        </b-col>
    </b-row>
</b-form>
</template>

<script>

import { resourceMapper } from '@/utils/resourceMapper.js';
import URLFilterInput from './URLFilterInput.vue';

export default {
    props: ['job'],
    methods: {
        onSubmit($e) {
            $e.preventDefault();
            this.job.save();
        }
    },
    computed: {
        ...resourceMapper([{
            propertyName: 'ingestion_filters',
            attributeName: 'job_criteria.ingestion_filters'
        }], 'job', 'url-management')
    },
    components: {
        URLFilterInput
    }
}
</script>
